import React, { useState, useEffect } from 'react';
import BoxContainer from '../BoxContainer/BoxContainer';
import { useForm } from 'react-hook-form';
import { Button as AntButton } from 'antd';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { useStateMachine } from 'little-state-machine';
import get from 'lodash/get';
import updateAction from '../CreateAccountWizard/updateAction';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import css from '../../styles/modules/TransferDetails/transferdetails.module.css';
import maxAmountValidator from './lib/form/maxAmountValidator';
import {
  PaymintsButton,
  BUTTON_TYPE,
} from 'paymints-address-autocomplete-field';

import {
  useCreateTransfer,
  useTransfer,
  useSaveTransfer,
} from '../../utils/service/service_transfer_api';
import { saveTransferDoc } from '../../reducers/transfer/TransferActions';
import { extractNotesFromJson, formatDayFromUTC } from '../../utils/util';
import useAllCreditTransferTypes from '../../hooks/useAllCreditTransferTypes';
import '../CreateAccountWizard/createAccount.css';
import './TransferDetails.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FieldsInfoTransfer from './components/FieldsInfoTransfer';
import { getDefaultValues } from './lib/getDefaultValue';
import { initPurposes } from './lib/stateInit/initPurposes';
import { submitTransfer } from './lib/submitTransfer';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import {
  clearLoading,
  setLoading,
} from '../../reducers/utility/utilityActions';
import SpinnerLoader from '../SpinnerLoader/SpinnerLoader';
import activateNext from './lib/activateNext';
import SubmissionForm from './components/SubmissionForm/SubmissionForm';
import directToPaymentSystem from './lib/routing/directToPaymentSystem';
import validateSubmission from './lib/form/validateSubmission';
import { singleUseAccountNumber } from '../../utils/service/v2/api';
import computeTransferStatus from './lib/utils/computeTransferStatus';
import displayPageHeader from '../../utils/displayPageHeadline';
import useWindowWidth from '../../hooks/nonGQLhooks/useWindowWidth';
import { closeNavbar } from '../../reducers/navbar/navbarActions';

function TransferDetails(props) {
  const { fieldOffices, tenant } = props;
  const sourceBankAccount = {};
  const tenantId = props?.tenant?._id;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const {
    amount,
    reAmount,
    city,
    street,
    street2,
    stateLocale,
    zip,
    notes,
    fieldOffice,
  } = useSelector((state) => state.clientTransferForm);
  /*
      this hook fetches the transfer again to avoid 
      double creation if user navigates back
   */
  const transfer_id = queryParams.get('transfer_id');
  const existingTransferId =
    props?.history?.location?.state?.existingTransferId;
  const { transfer } = useTransfer(existingTransferId || transfer_id);

  const history = useHistory();
  const expectedClosingDate = get(props, 'transfer.expectedClosingDate')
    ? formatDayFromUTC(get(props, 'transfer.expectedClosingDate'))
    : undefined;

  //Array<Obj> fee structure of this tenant
  const { transferFeeConfigData } = props;

  const {
    register,
    handleSubmit,
    errors,
    setValue,
    control,
    watch,
    getValues,
  } = useForm({
    defaultValues: {
      ...props.transfer,
      notes: extractNotesFromJson(props?.transfer?.notes),
      expectedClosingDate: expectedClosingDate,
      ...getDefaultValues(props),
    },
  });

  const { state } = useStateMachine(updateAction);
  const [nextDisabled, setNextDisabled] = useState(true);
  const [emdVisible, setFieldsEMDVisible] = useState(false);
  const [showREAInfoFill, setShowREAInfoFill] = useState(true);

  const [realtorData, setRealtorData] = useState({
    fullName: '',
    email: '',
    phoneNumber: '',
  });
  const { createTransfer } = useCreateTransfer();
  const [radioCheck, radioChecked] = useState({});

  const [MAXIMUM_AMOUNT, setMaximumAmount] = React.useState(null);
  const { saveTransfer } = useSaveTransfer();

  //closes navbar when the new page is entered in mobile
  const width = useWindowWidth();
  useEffect(() => {
    if (width < 768) {
      dispatch(closeNavbar());
    }
  }, []);

  useEffect(() => {
    // if (radioCheck?.limit) {
    setMaximumAmount(radioCheck?.limit || 0);
    // }
  }, [radioCheck]);

  const { data: creditTransferTypes, loading: loadingCreditTransferTypes } =
    useAllCreditTransferTypes();

  const [purposes, setPurposes] = useState([]);

  const [check, setCheck] = useState(false);
  const [checked, setChecked] = useState(null);

  // Assign the transfer value
  let transferData = transfer || null;

  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state).utility;
  // //------------------STATE INIT------------------------

  useEffect(() => window.scrollTo(0, 0), []);
  useEffect(() => {
    initPurposes(creditTransferTypes, props, setPurposes, setShowREAInfoFill);
  }, [creditTransferTypes]);

  useEffect(() => {
    dispatch(clearLoading());
  }, []);

  function handleGoBack() {
    dispatch(setLoading());

    // Delay the page transition to allow loading spinner to render
    setTimeout(() => {
      dispatch(clearLoading());
      history.push('/transfer-history');
    }, 100);
  }

  //handles the enabling of the next button once the form is completely filled out
  useEffect(() => {
    //office tenants need field offices. Below checks and calls activate next conditionally
    if (tenant?.routingType?.toLowerCase() === 'office') {
      activateNext(
        amount,
        reAmount,
        street,
        city,
        zip,
        stateLocale,
        setNextDisabled,
        true,
        fieldOffice,
      );
    } else {
      activateNext(
        amount,
        reAmount,
        street,
        city,
        zip,
        stateLocale,
        setNextDisabled,
        false,
      );
    }
  }, [amount, reAmount, street, city, zip, stateLocale, fieldOffice]);

  function submitForm(event) {
    event.preventDefault();

    try {
      if (!isLoading) {
        dispatch(setLoading());
        maxAmountValidator(
          { amount, reAmount, city, street, street2, stateLocale, zip, notes },
          MAXIMUM_AMOUNT,
          radioCheck?.method,
        );
        directToPaymentSystem(transferData, radioCheck, props);

        //checks if field office selection is required from user - office users need to select an office
        if (tenant?.routingType?.toLowerCase() === 'office') {
          validateSubmission(
            amount,
            reAmount,
            city,
            street,
            stateLocale,
            zip,
            true,
            fieldOffice,
          );
        } else {
          validateSubmission(
            amount,
            reAmount,
            city,
            street,
            stateLocale,
            zip,
            false,
          );
        }

        //computes the status to be displayed in the InfoCard.js tag
        const status = computeTransferStatus(radioCheck?.method);

        // creates the transfer, directs to the next screen
        submitTransfer(
          event,
          saveTransfer,
          transfer_id,
          dispatch,
          createTransfer,
          realtorData,
          transferFeeConfigData,
          state,
          // destAccount,
          sourceBankAccount,
          creditTransferTypes,
          props,
          { amount, reAmount, city, street, street2, stateLocale, zip, notes },
          radioCheck,
          tenantId,
          status,
          radioCheck?.method,
          fieldOffice,
        );
      } else {
        return;
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      dispatch(clearLoading());
    }
  }

  return (
    <div className={css.wrapper}>
      {isLoading ? <SpinnerLoader /> : null}
      <ToastContainer />
      <BoxContainer withDoubleBorder withTopLogo widest>
        <div className="create-account__line-container">
          <div className="create-account__title">
            {displayPageHeader(history?.location?.pathname)}
          </div>
        </div>
        <form onSubmit={(event) => submitForm(event)}>
          <FieldsInfoTransfer
            register={register}
            tenantId={get(props, 'tenant._id')}
            errors={errors}
            control={control}
            radioChecked={radioChecked}
            setValue={setValue}
            setChecked={setChecked}
            checked={checked}
            setCheck={setCheck}
            check={check}
            purposes={purposes}
            purposeFromTransfer={
              transfer && transfer.purpose ? transfer.purpose : undefined
            }
            emdVisible={emdVisible}
            setFieldsEMDVisible={setFieldsEMDVisible}
            realtorData={realtorData}
            setRealtorData={setRealtorData}
            client={get(props, 'client')}
            showREAInfoFill={showREAInfoFill}
            transfer={transfer}
          />

          <h5 className={css.tellUsText}>Complete your transfer details</h5>

          <br></br>
          <h5 className={css.allFieldsRequired}>
            All fields marked with an asterisk (*) are required.
          </h5>

          <SubmissionForm
            tenant={tenant}
            fieldOffices={fieldOffices}
            transferData={transferData}
            maximumAmount={MAXIMUM_AMOUNT}
          />

          <div className="d-flex justify-content-center mt-5">
            <PaymintsButton
              disabled={isLoading || nextDisabled}
              htmlType="submit"
              className="create-account__button"
              noShadow
              type={BUTTON_TYPE.INVERSE_BLUE}
              onClick={() => history.push('/create-account/step-3')}
            >
              Next
            </PaymintsButton>
          </div>
        </form>
      </BoxContainer>
    </div>
  );
}

export default withRouter(
  connect((state) => ({}), {
    onSaveTransferDoc: saveTransferDoc,
  })(TransferDetails),
);
